"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormSubmissionConstraintType = void 0;
var FormSubmissionConstraintType;
(function (FormSubmissionConstraintType) {
    FormSubmissionConstraintType["TIME"] = "TIME";
    FormSubmissionConstraintType["HOUR"] = "HOUR";
})(FormSubmissionConstraintType = exports.FormSubmissionConstraintType || (exports.FormSubmissionConstraintType = {}));
//# sourceMappingURL=formSubmissionConstraintType.js.map